// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Skeleton Component Styles
 * Additional styles specific to the Skeleton component.
 * Base animations are in index.css for global use.
 */

/* Skeleton List */
.skeleton-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.skeleton-list-item {
  opacity: 0;
  animation: skeletonFadeIn 0.3s ease-out forwards;
}

.skeleton-list-item:nth-child(1) { animation-delay: 0s; }
.skeleton-list-item:nth-child(2) { animation-delay: 0.1s; }
.skeleton-list-item:nth-child(3) { animation-delay: 0.2s; }
.skeleton-list-item:nth-child(4) { animation-delay: 0.3s; }
.skeleton-list-item:nth-child(5) { animation-delay: 0.4s; }

@keyframes skeletonFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Prompt card skeleton reflections */
.skeleton-prompt-reflections {
  margin-top: 1rem;
  margin-left: 2rem;
  padding-left: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .loading-page .loading-lantern-icon {
    width: 64px;
    height: 64px;
  }

  .loading-page .loading-lantern-text {
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/Skeleton.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gDAAgD;AAClD;;AAEA,mCAAmC,mBAAmB,EAAE;AACxD,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,qBAAqB,EAAE;;AAE1D;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/**\n * Skeleton Component Styles\n * Additional styles specific to the Skeleton component.\n * Base animations are in index.css for global use.\n */\n\n/* Skeleton List */\n.skeleton-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.skeleton-list-item {\n  opacity: 0;\n  animation: skeletonFadeIn 0.3s ease-out forwards;\n}\n\n.skeleton-list-item:nth-child(1) { animation-delay: 0s; }\n.skeleton-list-item:nth-child(2) { animation-delay: 0.1s; }\n.skeleton-list-item:nth-child(3) { animation-delay: 0.2s; }\n.skeleton-list-item:nth-child(4) { animation-delay: 0.3s; }\n.skeleton-list-item:nth-child(5) { animation-delay: 0.4s; }\n\n@keyframes skeletonFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Prompt card skeleton reflections */\n.skeleton-prompt-reflections {\n  margin-top: 1rem;\n  margin-left: 2rem;\n  padding-left: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .loading-page .loading-lantern-icon {\n    width: 64px;\n    height: 64px;\n  }\n\n  .loading-page .loading-lantern-text {\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
